export const cacheCleanupState = {
	callCount: 0,
};
